import { Box, Container, useTheme } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useStrategyStore } from "../../hooks/useStrategyStore";
import StoreHeader from "./components/StoreHeader";
import TimePeriodToggle from "./components/TimePeriodToggle";
import StoreFilters from "./components/StoreFilters";
import StrategyGrid from "./components/StrategyGrid";

const Store = () => {
  const theme = useTheme();

  const {
    loading,
    timePeriod,
    searchTerm,
    setSearchTerm,
    strategies,
    handleTimePeriodChange,
    pagination,
    currentPage,
    handlePageChange,
    filters,
    handleFiltersChange,
    availableOwners,
  } = useStrategyStore();


  return (
    <>
      <Helmet>
        <title>Store | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[50] : "#ebebeb",
          background: theme.palette.mode === "dark" ? theme.palette.grey[50] : "#ebebeb",
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <StoreHeader totalStrategies={pagination?.total} />
          <StoreFilters
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            filters={filters}
            onChange={handleFiltersChange}
            availableOwners={availableOwners}
          />
          <TimePeriodToggle
            value={timePeriod}
            onChange={handleTimePeriodChange}
          />
          <StrategyGrid
            strategies={strategies}
            loading={loading}
            searchTerm={searchTerm}
            pagination={pagination}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </Container>
      </Box>
    </>
  );
};

export default Store;

